import gql from 'graphql-tag'

export default gql`mutation removeProjectClientInvoiceCreditNote($invoice_id: Int!, $credit_note_id: Int!, $project_id: String!) {
    removeProjectClientInvoiceCreditNote(invoice_id: $invoice_id, credit_note_id: $credit_note_id, project_id: $project_id) @client
}`